import React from 'react';
import { usePlatformStatus } from '@/hooks/useSystemStatus';

// A representative subset of the feeds configured in backend/config.py (THREAT_SOURCES).
const SOURCES = [
  { n: 'CISA', c: 'US government advisories' },
  { n: 'SANS ISC', c: 'Internet Storm Center diaries' },
  { n: 'Cisco Talos', c: 'Vendor threat research' },
  { n: 'Unit 42', c: 'Palo Alto Networks research' },
  { n: 'Mandiant', c: 'Incident response research' },
  { n: 'Microsoft Security', c: 'Vendor threat intelligence' },
  { n: 'Securelist', c: 'Kaspersky research' },
  { n: 'SentinelLabs', c: 'SentinelOne research' },
  { n: 'Check Point Research', c: 'Vendor threat research' },
  { n: 'The Hacker News', c: 'Industry reporting' },
  { n: 'BleepingComputer', c: 'Malware and ransomware news' },
  { n: 'Krebs on Security', c: 'Investigative reporting' },
];

// Controls that exist in the product today. No certification is claimed
// until an audit has actually been passed.
const CONTROLS = [
  { t: 'MFA', d: 'TOTP for every account' },
  { t: 'Verified domains', d: 'DNS proof before any breach credential is shown' },
  { t: 'Audit trail', d: 'Sensitive actions are logged' },
  { t: 'Tenant isolation', d: 'Data scoped to your organization' },
  { t: 'Hardened egress', d: 'Webhooks restricted to public HTTPS endpoints' },
];

export default function WelcomeSources() {
  const { data } = usePlatformStatus();
  const total = data?.sources_total;

  return (
    <>
      <section id="sources" className="wl-section wl-section--rule" aria-labelledby="wl-sources-title">
        <div className="wl-container">
          <div className="wl-sources-layout">
            <div>
              <div className="wl-eyebrow">Intelligence sources</div>
              <h2 id="wl-sources-title" className="wl-h2">
                {typeof total === 'number' ? `${total} public feeds,` : 'Public feeds,'} <em>one view.</em>
              </h2>
              <p className="wl-lede" style={{ fontSize: 'var(--fs-base)' }}>
                Government advisories, vendor research labs and established security
                publications. When several outlets cover the same event, you get one brief that
                combines what each of them reports, with links back to every source.
              </p>
            </div>

            <ul className="wl-sources-grid" aria-label="Example sources">
              {SOURCES.map((s) => (
                <li key={s.n}>
                  <div className="wl-source-name">{s.n}</div>
                  <div className="wl-source-kind">{s.c}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section id="security" className="wl-section wl-section--band" aria-labelledby="wl-security-title">
        <div className="wl-container">
          <div className="wl-controls-layout">
            <div>
              <div className="wl-eyebrow">Security controls</div>
              <h2 id="wl-security-title" className="wl-h2">
                Built for teams that handle <em>sensitive data.</em>
              </h2>
            </div>
            <ul className="wl-controls">
              {CONTROLS.map((c) => (
                <li key={c.t}>
                  <div className="wl-control-name">{c.t}</div>
                  <div className="wl-control-desc">{c.d}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
